/*
  Live discount prices (added 22 Sep 2026)
  Asks Shopify what each product on the page really costs right now, by
  building a throwaway cart through the Storefront API. Whatever automatic
  discounts are switched on in Shopify admin show up here straight away,
  and anything switched off disappears. Nothing is hard-coded, so new
  collection discounts work without touching the theme.
  If anything fails, the normal price stays on screen.
  The shopper's real cart is never touched.
*/
(function () {
  'use strict';
  if (window.__liveDiscountPrices) return;
  window.__liveDiscountPrices = true;

  var cfg = window.liveDiscountConfig || {};
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var ENDPOINT = ROOT.replace(/\/$/, '') + '/api/2025-07/graphql.json';
  var CHUNK = 50;
  var cache = {};    // variantId -> {orig, now} in cents, or null for "no discount"
  var pending = {};  // variantId -> true while a request is out

  var QUERY = 'mutation($lines:[CartLineInput!]!,$bi:CartBuyerIdentityInput){cartCreate(input:{lines:$lines,buyerIdentity:$bi}){cart{lines(first:' + CHUNK + '){nodes{quantity merchandise{... on ProductVariant{id}} cost{subtotalAmount{amount} compareAtAmountPerQuantity{amount}} discountAllocations{discountedAmount{amount} ... on CartAutomaticDiscountAllocation{discountApplication{targetType allocationMethod}}}}}} userErrors{message}}}';

  function cents(amount) { return Math.round(parseFloat(amount) * 100); }

  function formatMoney(c) {
    var fmt = cfg.moneyFormat || '${{amount}}';
    var dollars = Math.floor(c / 100);
    var cc = ('0' + (c % 100)).slice(-2);
    var withCommas = function (n, sep) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return withCommas(Math.round(c / 100), ',');
        case 'amount_with_comma_separator': return withCommas(dollars, '.') + ',' + cc;
        case 'amount_no_decimals_with_comma_separator': return withCommas(Math.round(c / 100), '.');
        default: return withCommas(dollars, ',') + '.' + cc;
      }
    });
    // Same superscript cents rule as snippets/price-as-money.liquid
    if (cfg.supercents && fmt.indexOf('money') === -1 && fmt.indexOf('.') === -1) {
      var sep = fmt.indexOf('amount_with_comma_separator') !== -1 ? ',' : '.';
      var i = out.lastIndexOf(sep);
      if (i !== -1) out = out.slice(0, i) + '<sup>' + out.slice(i + 1) + '</sup>';
    }
    return out;
  }

  function request(ids) {
    var lines = ids.map(function (id) { return { merchandiseId: 'gid://shopify/ProductVariant/' + id, quantity: 1 }; });
    var body = { query: QUERY, variables: { lines: lines, bi: cfg.country ? { countryCode: cfg.country } : null } };
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body),
      credentials: 'omit'
    }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (json) {
        var cart = json && json.data && json.data.cartCreate && json.data.cartCreate.cart;
        if (!cart) throw new Error('no cart');
        var seen = {};
        cart.lines.nodes.forEach(function (line) {
          var id = line.merchandise && line.merchandise.id && line.merchandise.id.split('/').pop();
          if (!id) return;
          var qty = line.quantity || 1;
          var orig = Math.round(cents(line.cost.subtotalAmount.amount) / qty);
          var off = 0;
          (line.discountAllocations || []).forEach(function (a) {
            var app = a.discountApplication;
            // Only product-level automatic discounts. Order and shipping discounts are ignored.
            if (app && app.targetType === 'LINE_ITEM') off += cents(a.discountedAmount.amount);
          });
          off = Math.round(off / qty);
          var cmp = line.cost.compareAtAmountPerQuantity ? cents(line.cost.compareAtAmountPerQuantity.amount) : 0;
          seen[id] = true;
          cache[id] = off > 0 && off < orig ? { orig: orig, now: orig - off, compare: cmp } : null;
        });
        // Variants Shopify would not add (sold out etc.) keep their normal price
        ids.forEach(function (id) { if (!seen[id] && !(id in cache)) cache[id] = null; });
      })
      .catch(function (err) {
        // One bad variant can sink a whole batch, so split and retry
        if (ids.length > 1) {
          var half = Math.ceil(ids.length / 2);
          return Promise.all([request(ids.slice(0, half)), request(ids.slice(half))]);
        }
        cache[ids[0]] = null;
        if (window.console) console.debug('[live-discount-prices]', err);
      });
  }

  function apply(el) {
    var id = el.getAttribute('data-dp-variant');
    var result = cache[id];
    if (!result) return;
    var def = el.querySelector('.price__default');
    var current = el.querySelector('.price__default .price__current');
    if (!def || !current) return;
    var nowHtml = formatMoney(result.now);
    if (el.getAttribute('data-dp-done') === id && current.innerHTML === nowHtml) return;

    // Another app (e.g. customer pricing) has already changed this price: leave it alone.
    var rendered = el.getAttribute('data-dp-rendered');
    if (rendered !== null && el.getAttribute('data-dp-done') !== id &&
        current.textContent.replace(/\s/g, '') !== rendered.replace(/\s/g, '')) return;

    var was = Math.max(result.compare || 0, result.orig);
    var pct = Math.round((result.orig - result.now) / result.orig * 100);

    current.innerHTML = nowHtml;
    var s = def.querySelector('.price__was');
    if (!s) { s = document.createElement('s'); s.className = 'price__was'; current.insertAdjacentElement('afterend', s); }
    s.innerHTML = formatMoney(was);
    el.classList.add('price--on-sale');

    var badge = def.querySelector('.live-discount-badge');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'live-discount-badge';
      s.insertAdjacentElement('afterend', badge);
    }
    badge.textContent = (cfg.badgeText || '[amount]% off').replace('[amount]', pct);
    el.setAttribute('data-dp-done', id);
  }

  function scan() {
    var els = document.querySelectorAll('[data-dp-variant]');
    var need = [];
    Array.prototype.forEach.call(els, function (el) {
      var id = el.getAttribute('data-dp-variant');
      if (!id) return;
      if (el.getAttribute('data-dp-rendered') === null) {
        var cur = el.querySelector('.price__default .price__current');
        if (cur) el.setAttribute('data-dp-rendered', cur.textContent);
      }
      if (id in cache) apply(el);
      else if (!pending[id] && need.indexOf(id) === -1) need.push(id);
    });
    for (var i = 0; i < need.length; i += CHUNK) {
      var batch = need.slice(i, i + CHUNK);
      batch.forEach(function (id) { pending[id] = true; });
      request(batch).then(function () {
        batch.forEach(function (id) { delete pending[id]; });
        scheduleScan();
      });
    }
  }

  // Product page: the theme's variant picker rewrites the price in place,
  // so point the price block at the newly chosen variant and start again.
  function onVariantInput(e) {
    var input = e.target;
    if (!input || input.name !== 'id' || !input.value) return;
    var scope = input.closest('.shopify-section') || document;
    Array.prototype.forEach.call(scope.querySelectorAll('.product-info__price > .price[data-dp-variant]'), function (el) {
      if (el.getAttribute('data-dp-variant') === String(input.value)) return;
      el.removeAttribute('data-dp-done');
      el.removeAttribute('data-dp-rendered');
      var badge = el.querySelector('.live-discount-badge');
      if (badge) badge.parentNode.removeChild(badge);
      el.setAttribute('data-dp-variant', input.value);
    });
    scheduleScan();
  }

  var timer = null;
  function scheduleScan() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; scan(); }, 60);
  }

  function start() {
    scan();
    document.addEventListener('change', onVariantInput, true);
    // Infinite scroll, filters, quick add, variant changes, cart drawer
    new MutationObserver(scheduleScan).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-dp-variant'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
